enum EnergyType {
    Gas,
    Electricity,
    Heat,
    Cold
}

export default EnergyType;